module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    style: ({
      minHeight: _vm.minHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "button-group"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.$router.go({
            name: 'survey-result-detail',
            query: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getTitle(item)) + "\n        ")])
  })), _vm._v(" "), _c('BottomBar', {
    attrs: {
      "index": 2
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08ddf8d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey-result-list.vue
// module id = 281
// module chunks = 1